<div class="dialog-header">
    <button  class="dialog-close" mat-icon-button mat-dialog-close (click)="onNoClick()">
        <mat-icon>close</mat-icon>
    </button>
    <h1 class='h3' mat-dialog-title>{{ title }}</h1>
</div>

<div class="dialog-content">
    <div class="order-recap-cart mat-elevation-z0">
        <ng-container *ngTemplateOutlet="cartItems"></ng-container>
        <ng-container *ngTemplateOutlet="cartSummary"></ng-container>
    <div>
    
<div mat-dialog-actions *ngIf="data.actions && data.actions.length > 0 && data.orderElement">
    {{ 'Order total' | translate }} {{data.orderElement.order_value | currency: 'EUR'}}
    <ng-container *ngIf="data.actions && data.actions.length > 0 && data.orderElement">
        <button *ngFor="let item of data.actions" mat-button (click)="item.action(data.orderElement)">{{item.label}}</button>
    </ng-container>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</div>

<ng-template #loader>
    <ng-container *ngIf="!noOrderFound">
        <mat-spinner diameter="60" class="order-recap-loader"></mat-spinner>
    </ng-container>
</ng-template>



<ng-template #cartItems>
    <div class="order-products-list-cart pb--0 ">
       <div class="h5 fw-bold">{{'Products in order' | translate}}</div>
        <ng-container *ngIf="productsToBuy; else loader">
            <ng-container *ngFor="let product of productsToBuy; let lastidx = last">
                <div class="product-item d-flex align-items-center gap-16">
                    <img *ngIf="product.image_url" class="product-thumbnail" [src]="product.image_url" width="70" height="70"
                        [attr.alt]="product.name" />
                    <!-- <div class="product-details"> -->
                        <h3 class="product-name mb--0">{{product.name}}</h3>
                        <!-- <div class="product-description" [innerHTML]="product.description"> -->
                        <!-- </div> -->
                    <!-- </div> -->
                </div>
                <mat-divider class="mb--24"></mat-divider>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
<ng-template #cartSummary>
    <div class="order-cart-totals">
       <div class="h5 fw-bold">{{'Order summary' | translate}}</div>
        <ng-container *ngIf="orderSummary; else loader">
            <div class="list-summary mt--24 ">
                <div class="list-item">
                    <span class="label">{{'label.order_date' | translate}}</span>
                    <span class="value">{{orderSummary.createdDate | date}}</span>
                </div>
                <div class="list-item">
                    <span class="label" translate>{{acceptanceType == 'splitted' ? 'label.deposit' : 'label.subtotal' }}</span>
                    <span class="value">{{orderSummary.subtotal | currency}}</span>
                </div>
                <div class="list-item">
                    <span class="label">{{'label.tax' | translate}}</span>
                    <span class="value">{{orderSummary.tax | currency}}</span>
                </div>
                <mat-divider></mat-divider>
                <div class="list-item list-total">
                    <span class="label" translate>{{acceptanceType == 'splitted' ? 'label.total_deposit' : 'label.total_order'  }}</span>
                    <span class="value">{{orderSummary.total | currency}}</span>
                </div>
            </div>
            <ng-container *ngIf="orderSummary.offer">
                <div class="h5 fw-bold">{{'Promo offer' | translate}}</div>
                <div class="offer-term" *ngIf="acceptanceType == 'splitted'"><small>{{ 'Da pagare entro 30 giorni' | translate }}</small></div>
                <div class="list-summary" >
                    <div class="list-item list-offer">
                        <span class="label" translate>{{acceptanceType == 'splitted' ? 'label.balance' : 'label.offer'  }}</span>
                        <span class="value">{{orderSummary.offersubtotal | currency}}</span>
                    </div>
                    <div class="list-item list-offer">
                        <span class="label" >{{'label.tax' | translate}}</span>
                        <span class="value">{{orderSummary.offertax | currency}}</span>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="list-item list-offer list-total">
                        <span class="label" translate>{{acceptanceType == 'splitted' ? 'label.total_balance' : 'label.total_balance_offer' }}</span>
                        <span class="value">{{orderSummary.offer | currency}}</span>
                    </div>

                </div>
            </ng-container>
        </ng-container>

    </div>
</ng-template>
